import {
  Stack,
  HStack,
  Divider,
  CircularProgress,
  useToast,
} from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navigate from "./components/Navigate";
import MultiTaskBar from "./components/MultiTaskBar";
import { io } from "socket.io-client";
import { NotificationsContext } from "../../contexts/notificationContext";
import { useSelector } from "react-redux";

const Layout = (props) => {
  const {
    expanded,
    setExpanded,
    mobile,
    filter,
    setFilter,
    usuario,
    setUsuario,
    loading,
  } = props;

  const { user } = useSelector((state) => state.user);

  const { setNotificaciones, setNotificacionGlobalActivas } =
    useContext(NotificationsContext);

  const socket = io(process.env.REACT_APP_URL, {
    // transports: ["websocket", "polling"], // Probar con 'websocket' y 'polling'
    withCredentials: true,
  });

  const toast = useToast();

  useEffect(() => {
    const username = user.username;
    socket.emit("registerUser", username);
    socket.on("nuevoRegistroNotificaciones", (notificacion) => {
      setNotificaciones((prev) => [notificacion, ...prev]);
      setNotificacionGlobalActivas(true);
      toast({
        title: "¡Alerta!",
        description:
          notificacion && notificacion?.descripciónNBS
            ? notificacion?.descripciónNBS
            : "Revisa las notificaciones",
        status: "warning", // Puedes usar 'success', 'error', 'warning' o 'info'
        duration: 3000, // Duración en milisegundos
        isClosable: true, // Puede cerrarse haciendo clic en la 'X'
      });
    });

    socket.on("connect_error", (error) => {
      if (socket.active) {
        // temporary failure, the socket will automatically try to reconnect
        console.log("Error de conexión: ", error.message);
        console.log("Conectado al servidor: ", socket.connected);
        console.log("Intentando reconexión...");
      } else {
        // the connection was denied by the server
        // in that case, `socket.connect()` must be manually called in order to reconnect
        console.log(error.message);
      }
    });

    return () => {
      socket.off("nuevoRegistroNotificaciones"); // Desconectar el socket al desmontar el componente
      console.log("Conectado del servidor: ", socket.connected);
    };
  }, [socket.connected]);

  const loadingtable = () => {
    return (
      <HStack w="100%" placeContent="center">
        <CircularProgress isIndeterminate color="brand.naranja" />
      </HStack>
    );
  };

  return (
    <HStack w="100vw">
      {mobile && (
        <Navigate
          mobile={mobile}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      )}
      {loading && loadingtable()}
      {!loading && (
        <Stack
          bg="brand.fondos_secundarios"
          w="100%"
          h={"100vh"}
          overflowY={"hidden"}
        >
          <MultiTaskBar
            mobile={mobile}
            filter={filter}
            setFilter={setFilter}
            // notificaciones={notificaciones}
            // setNotificaciones={setNotificaciones}
            expanded={expanded}
            setExpanded={setExpanded}
            usuario={usuario}
            setUsuario={setUsuario}
            loading={loading}
          />
          <Divider bg="blackAlpha.50" w={"100%"} />
          <Outlet expanded={expanded} />
        </Stack>
      )}
    </HStack>
  );
};

export default Layout;
